// ЗАПАСНЫЕ ФОРМЫ ЭКРАНОВ САЙТА (APP-CLAIMS-1020 ред. 9, §2.2, 7.4.4) — снимает водитель маршрутов (`e2e/routes/_shape.js`,
// команда `shape <маршрут>`), по файлу на маршрут: `<маршрут>.json`. Формат — `ShapeSchema` (lib/app-page.ts), подробно —
// README.md рядом. Из формы `<Shape/>` (skeleton.tsx) строит заглушку, если своей формы на устройстве ещё нет.
//
// Файлы подключаются ЯВНЫМ импортом (прод-сборка папку не читает): `import bots from './bots.json';` и строка в FILES.
// Замок — shapes.test.ts: каждый `*.json` папки подключён и похож на форму.
import { shapeKeyOf, type Shape } from '@/lib/shape';
import account from './account.json';
import bots from './bots.json';
import broadcasts from './broadcasts.json';
import chats from './chats.json';
import contacts from './contacts.json';
import helpArticle from './help-article.json';

/** Сырые формы папки — по строке на файл. */
// Снято ведущим 21.10.2026 на своём сервере с копией базы (учётка shots@): маршрут e2e/routes/shapes-main.route.
// Статья справки в слое (ред. 11, Д4) — маршрут e2e/routes/shapes-r11.route, там же пересняты bots/chats/contacts/account (без
// изменений).
const FILES: readonly unknown[] = [account, bots, broadcasts, chats, contacts, helpArticle];

let byKey: Record<string, Shape> | null = null;
/** Форма по ключу `<маршрут>|<вид>` (карта строится при первом обращении — без цикла импортов с lib/shape.ts). */
export function siteShape(id: string): Shape | undefined {
  byKey ??= Object.fromEntries((FILES as Shape[]).map((s) => [shapeKeyOf(s.key, s.view), s]));
  return byKey[id];
}

/** Для замка: сырые файлы. */
export const SITE_SHAPE_LIST: readonly unknown[] = FILES;

/** Сколько файлов подключено (замок сверяет с числом `*.json` в папке). */
export const SITE_SHAPE_FILES = FILES.length;
